<template>
    <!-- https://codepen.io/zz85/pen/gbOoVP -->
    <div>

        <div id="drag_pane">
            <div id="drag_head">
                <div id="drag_title">Chart-Summary</div>
                <div>
                    <span id="drag_reset"></span>
                    <span id="drag_close">&#10006;</span>
                </div>

            </div>
            <div>
                <slot name="content"></slot>
            </div>
        </div>
        <div id="ghostpane"></div>
    </div>
</template>



<script>
import { dragaction, positioninfo } from './dragbox.js'
export default {

    mounted() {
        dragaction(this)
    },
    methods: {

    }
}

</script>

<style>
#drag_title{
    float:left;
    text-align:left;
    width:70%
}

#drag_reset:hover {
    color: blue;
    font-weight: bold;
}

#drag_close:hover {
    color: rgb(255, 0, 64);
    font-weight: bold;
}

#drag_pane {
    position: relative;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    z-index: 99;
    border: 2px solid purple;
    background: #fefefe;
    overflow: scroll
}

#drag_head {

    font-family: monospace;
    background: rgb(105, 45, 127);
    color: white;
    font-size: 24px;
    height: 30px;
    width:100%;
    display: flex;
    justify-content:space-around
    /* align-items: stretch; */
}

#ghostpane {
    background: #999;
    opacity: 0.2;

    /* width: 45%;
    height: 45%;
    top: 20%;
    left: 20%; */

    width: 0;
    height: 0;
    top: 0;
    left: 0;

    position: absolute;
    margin: 0;
    padding: 0;
    z-index: 0;

    -webkit-transition: all 0.25s ease-in-out;
    -moz-transition: all 0.25s ease-in-out;
    -ms-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
}
</style>


// WEBPACK FOOTER //
// src/components/utility/dragbox/dragbox.vue